import { useEffect, useState, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useDropzone } from 'react-dropzone';

import Loading from '../../Loading/Loading';
import { useFileManagement } from './useFileManagement';

import { FaDownload, FaUpload, FaTrashAlt } from "react-icons/fa";
import { CiImageOff } from "react-icons/ci";
import './FileManagement.css';
import BaseModal from '../Base/BaseModal';

const FileManagement = ({ row, fileCode ,onClose }) => {
    
    const dispatch = useDispatch();
    const session = useSelector((state) => state.session.data);
    const files = useSelector((state) => state.file.data);
    const fileApi = useFileManagement();
    
    const [fileSeq, setFileSeq] = useState(0);
    const [fileBundleSeq, setFileBundleSeq] = useState(0);
    const [activeTab, setActiveTab] = useState(1);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [selectedFiles, setSelectedFiles] = useState([]);
    const [progress, setProgress] = useState(0);

    const refreshList = useCallback(async () => {
        if (!fileBundleSeq) return;
        await fileApi.getFileList(fileBundleSeq);
        setCurrentIndex(0);
    }, [fileApi, fileBundleSeq]);

    const onDrop = useCallback(async (acceptedFiles) => {
        const formData = new FormData();
        acceptedFiles.forEach(file => {
            formData.append('files', file);
        });
        formData.append('fileBundleSeq', fileBundleSeq);
        formData.append('companySeq', session.companySeq);
        formData.append('fileCode', fileCode);

        await fileApi.fileUpload(formData).then(() => {
            fileApi.getFileList(fileBundleSeq);
            if (activeTab === 1) {
                setCurrentIndex(0);
            }
        });
        await refreshList();
        }, [fileBundleSeq, session.companySeq, fileCode, fileApi, activeTab]);

    const { getRootProps, getInputProps, isDragActive, open } = useDropzone({ onDrop, noClick: true, noKeyboard: true });

    useEffect(() => {
        if (row.imageFileBundleSeq && activeTab === 1) {
            setFileBundleSeq(row.imageFileBundleSeq || 0);
        } else if (row.documentFileBundleSeq && activeTab === 2) {
            setFileBundleSeq(row.documentFileBundleSeq || 0);
        }
    }, [dispatch, activeTab]);
    
    useEffect(() => {
        if (activeTab === 1 && files.length > 0) {
            setFileSeq(files[currentIndex]?.fileSeq ?? 0);
        } else {
            setFileSeq(0);
        }
    }, [files, currentIndex, activeTab]);

    useEffect(() => {
        if (fileBundleSeq !== 0) {
            fileApi.getFileList(fileBundleSeq).then(data => {
                setCurrentIndex(0);
            });
        }
    }, [fileBundleSeq]);

    useEffect(() => {
        if (activeTab === 1) {
            if (row?.imageFileBundleSeq) {
                setFileBundleSeq(row.imageFileBundleSeq);
            } else if (row?.documentFileBundleSeq) {
                setActiveTab(2);
                return;
            } else {
                setFileBundleSeq(0);
            }
        } else if (activeTab === 2) {
            if (row?.documentFileBundleSeq) {
                setFileBundleSeq(row.documentFileBundleSeq);
            } else if (row?.imageFileBundleSeq) {
                setActiveTab(1);
                return;
            } else {
                setFileBundleSeq(0);
            }
        }
    }, [activeTab, row?.imageFileBundleSeq, row?.documentFileBundleSeq]);

    const prevImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex === 0 ? files.length - 1 : prevIndex - 1));
        setFileSeq(files[currentIndex].fileSeq)
    };
    const nextImage = () => {
        setCurrentIndex((prevIndex) => (prevIndex === files.length - 1 ? 0 : prevIndex + 1));
        setFileSeq(files[currentIndex].fileSeq)
    };
    
    return (
        <div className="fm-container">
            {files.loading && <Loading />}
            <div className="fm-tabs">
                {row.imageFileBundleSeq && (<button className={activeTab === 1 ? 'active' : ''} onClick={() => setActiveTab(1)}>이미지</button>)}
                {row.documentFileBundleSeq && (<button className={activeTab === 2 ? 'active' : ''} onClick={() => setActiveTab(2)}>문서</button>)}
            </div>
            <div className={`fm-section${activeTab === 1 ? ' image-mode' : ' document-mode'} ${isDragActive ? ' drag-active' : ''}`}
                {...getRootProps({ onClick: (e) => e.stopPropagation() })}>
                <input {...getInputProps()} />

            {activeTab === 1 ? (
                files.length > 0 ? (
                <>
                    <button className="fm-arrow left" onClick={prevImage}>&lt;</button>
                    <div className="fm-image-wrapper">
                    <img src={files[currentIndex].url} alt={`Slide ${currentIndex}`} />
                    </div>
                    <button className="fm-arrow right" onClick={nextImage}>&gt;</button>
                </>
                ) : (
                <div className="fm-image-wrapper">
                    <CiImageOff size={320} color="#888" />
                </div>)
                ) : (
                <>
                    <div className="document-container">
                        {files.map((doc, index) => (
                            <div key={index} className="document-item">
                                <span className="doc-name">{doc.name}</span>
                                <div>
                                    <FaDownload onClick={() => { fileApi.fileDownload(doc.fileSeq) }} size={20} className="doc-download"/>
                                    <FaTrashAlt onClick={()=>{ fileApi.fileDelete(doc.fileSeq) }} size={20} className='doc-delete'/>
                                </div>
                            </div>))}
                    </div>
                </>)}
                {isDragActive && (
                <div className="fm-drop-overlay">
                    여기에 파일을 놓으면 업로드됩니다
                </div>)}
            </div>
            <div className='fm-footer'>
                <div className='fm-btn-group'>
                    <FaUpload onClick={open} style={{ cursor: 'pointer' }} size={20} />
                    {activeTab === 1 ? 
                        <>
                            <FaDownload onClick={()=>{ fileApi.fileDownload(fileSeq) }}  size={20}  className="download"/>
                            <FaTrashAlt onClick={()=>{ fileApi.fileDelete(fileSeq) }} size={20} className="delete"/>
                        </>
                    : null}
                </div>
                <div className='btn-group'>
                    <button onClick={onClose} className="btnClose">닫기</button>
                </div>
            </div>
        </div>
    );
};

export default FileManagement;
